@if (type === 'restaurant') {
  <app-dining-details-page [data]="routeData"></app-dining-details-page>
} @else if (type === 'destination' || type === 'all') {
  <app-dinings-page [data]="routeData"></app-dinings-page>
}
